import { NgModule } from "@angular/core";
import { OidcCustomStorageService } from "@core/services/oidc-custom-storage.service";
import { AbstractSecurityStorage, AuthModule, LogLevel } from "angular-auth-oidc-client";

@NgModule({
  imports: [
    AuthModule.forRoot({
      config: {
        authority: "https://econnect-is-sts.endepro.net",
        redirectUrl: window.location.origin /*+'/operari'*/,
        postLogoutRedirectUri: window.location.origin,
        clientId: "2B3C0A5E-AC43-4CD9-A83B-7BF1B239D755",
        scope: "openid profile econnect-api",
        responseType: "code",
        silentRenew: true,
        useRefreshToken: true,
        logLevel: LogLevel.None,
        maxIdTokenIatOffsetAllowedInSeconds: 3600,
      },
    }),
  ],
  providers: [
    { provide: AbstractSecurityStorage, useClass: OidcCustomStorageService },
  ],
  exports: [AuthModule],
})
export class AuthConfigModule {}
